import { MijnRoute } from '../../mijn-navigatie.model';

export const BUDGET_EDIT: MijnRoute = {
    path: 'aanpassen',
    navigationEvent: 'toBudgetEdit',
    regex: /^\/budgetten\/aanpassen$/,
    webcomponent: 'mijn-budget-webcomponent',
    internalPath: '/aanpassen'
};
